import { ref, watch } from 'vue'
import api from '@/services/api'
import { player, usePlayer } from '@/composables/game/player'
import { ongoingTap } from '@/composables/game/ongoing-tap'
import { useAnalytics } from '@/composables/analytics'
import { DateTime } from 'luxon'

const debounceDuration = 1500
const { triggerEvent } = useAnalytics()

export const useTap = () => {
  const { convertTapToCoin, player } = usePlayer()
  const timeoutRef = ref<ReturnType<typeof setTimeout>>()

  watch(() => ongoingTap.value.count, (tapsCount, oldTapCount) => {
    if (tapsCount === 0) return
    clearTimeout(timeoutRef.value)
    timeoutRef.value = setTimeout(syncTap, debounceDuration)
    ongoingTap.value.lastTapAvailableEnergy = convertTapToCoin(tapsCount - oldTapCount)
    if (ongoingTap.value.startTimestamp === 0) ongoingTap.value.startTimestamp = Date.now()
  })

  function tap(count: number) {
    const availableTap = Math.floor(player.value.energy.available / player.value.tap.earnPerTap)
    const toTap = Math.min(count, availableTap)
    ongoingTap.value.count += toTap
    return toTap
  }

  return { tap }
}

export async function syncTap() {
  const { lastTapAvailableEnergy, count, startTimestamp } = ongoingTap.value
  if (count < 5) return
  ongoingTap.value = {
    count: 0,
    startTimestamp: 0,
    lastTapAvailableEnergy: 0,
  }
  const tapDuration = Math.max(0, Math.floor((Date.now() - startTimestamp - debounceDuration) / 1000))
  const { activities } = await api.tap({
    count: count,
    availableEnergy: lastTapAvailableEnergy,
    duration: tapDuration,
    startTimestamp: Math.floor(startTimestamp / 1000),
  })
  triggerEvent({ event: 'tap', value: count * player.value.tap.earnPerTap })
  triggerEvent({ event: 'earn_virtual_currency', value: count * player.value.tap.earnPerTap })
  player.value = { ...player.value, activities, lastUpdate: DateTime.utc().toSeconds() }
}
